export default __webpack_public_path__ + "static/media/opinion3.1.7360433b.jpg";